import React from 'react'
import { AlertMessage, Container, Contents, LoadingContainer } from './styles'
import { SessionTitle } from '../SessionTitle'
import { IconComponent } from '~/assets/icons/component'
import { SpinnerIconLoader } from '~/components/shared'
import { useLaboratoryHealthProcedures } from '~/context'
import { message } from '~/services'
import { ELaboratoryTestQualitativePropertySubtypes, LaboratoryTestQualitativeProperty } from '~/interfaces'

const Antibiogram: React.FC = () => {
  const { selectedUrineCultureProperties, isLoadingTestProperties } = useLaboratoryHealthProcedures()
  const antibiograms = selectedUrineCultureProperties?.filter(
    properties =>
      'subtype' in properties &&
      properties?.subtype === ELaboratoryTestQualitativePropertySubtypes.ANTIBIOTIC_RESISTANCE
  ) as LaboratoryTestQualitativeProperty[]

  const render = () => {
    if (isLoadingTestProperties) {
      return (
        <LoadingContainer>
          <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
        </LoadingContainer>
      )
    }
    if (!isLoadingTestProperties && antibiograms?.length === 0) {
      return (
        <AlertMessage>
          <span>{message('laboratory.not_found_antibiogram')}</span>
        </AlertMessage>
      )
    }

    return (
      <ul>
        {antibiograms?.map((antibiogram, index) => (
          <li data-testid="antibiotic" key={index}>
            <strong>
              {antibiogram.name}: {antibiogram.value}
            </strong>
            <br />
            {antibiogram?.referenceValue && `Ref.: ${antibiogram.referenceValue}`}
          </li>
        ))}
      </ul>
    )
  }

  return (
    <Container>
      <SessionTitle title={message('laboratory.antibiogram')} descriptionDate={antibiograms?.[0]?.date} />
      <Contents>{render()}</Contents>
    </Container>
  )
}

export { Antibiogram }
